import listActions from 'src/modules/pregunta/list/preguntaListActions';
import PreguntaService from 'src/modules/pregunta/preguntaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PREGUNTA_DESTROY';

const preguntaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: preguntaDestroyActions.DESTROY_STARTED,
      });

      await PreguntaService.destroyAll([id]);

      dispatch({
        type: preguntaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.pregunta.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/pregunta');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: preguntaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: preguntaDestroyActions.DESTROY_ALL_STARTED,
      });

      await PreguntaService.destroyAll(ids);

      dispatch({
        type: preguntaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.pregunta.destroyAll.success'),
      );

      getHistory().push('/pregunta');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: preguntaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default preguntaDestroyActions;
